import styled from 'styled-components';

const ChooseModelContainer = styled.div`
  display: grid;
  grid-template-columns: 70% 30%;
  
  & > div:nth-child(2) {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

const Label = styled.p`
  font-family: Inter;
  font-weight: 600;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0px;
  vertical-align: middle;
`;

const Description = styled.p`
font-family: Inter;
font-weight: 400;
font-size: 14px;
line-height: 100%;
letter-spacing: 0px;
vertical-align: middle;
`;

export {
  ChooseModelContainer,
  Label,
  Description,
};
